import { styled } from '@mui/material/styles';

import { MIN_WIDTH_LG } from '../../theme/Theme';
import { resolveTypographyFromTheme } from '../../../theming/tokens/font.helper';

const marginTopBottomMobile = ({ hasContent, marginTopBottomMobile: margin }) => {
  if (!hasContent) return '0';

  if (Number.isFinite(margin)) {
    return `${margin}rem`;
  }

  return '1.5rem';
};

const marginTopBottomDesktop = ({ hasContent, marginTopBottomDesktop: margin }) => {
  if (!hasContent) return '0';

  if (Number.isFinite(margin)) {
    return `${margin}rem`;
  }

  return '3rem';
};

export const StyledPageHeaderContainer = styled('div')`
  margin: ${marginTopBottomMobile} 0;
  text-align: ${({ theme }) => theme?.widgets?.pageHeader?.textAlign};

  @media only screen and (min-width: ${MIN_WIDTH_LG}) {
    margin: ${marginTopBottomDesktop} 0;
  }
`;

export const StyledPageHeaderImageContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
`;

export const StyledPageHeaderImage = styled('img')`
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  box-shadow: ${({ theme }) => theme?.shadows[1]};
`;

export const StyledPageHeaderTextContainer = styled('div')`
  height: ${(props) => (props?.contentHeight > 0 ? `${props.contentHeight}px` : 'auto')};
  text-align: ${({ theme }) => theme?.widgets?.pageHeader?.textAlign};
`;

export const StyledPageHeaderTitle = styled('h1')(({ theme }) => ({
  margin: '0 0 1rem',
  wordBreak: 'break-word',
  ...resolveTypographyFromTheme(theme, 'widgets.pageHeader.typography.title', 'h1'),
  color: theme?.widgets?.pageHeader?.color?.title,

  em: {
    textDecoration: 'none',
    fontStyle: 'normal',
    backgroundColor: theme?.palette?.background?.pageHeaderTitle,
  },
}));

export const StyledPageHeaderDescription = styled('p')(({ theme }) => ({
  margin: 0,
  padding: 0,
  ...resolveTypographyFromTheme(theme, 'widgets.pageHeader.typography.description', 'body'),
  color: theme?.widgets?.pageHeader?.color?.description,
  wordBreak: 'break-word',
}));
